import React from 'react'

export default function DownloadButtonIcon () {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_220_338)">
            <path d="M7.65625 1.15625V0.5H6.34375V1.15625V8.5418L3.74609 5.94414L3.28125 5.4793L2.3543 6.40625L2.81914 6.87109L6.53516 10.5898L7 11.0547L7.46484 10.5898L11.1836 6.87109L11.6484 6.40625L10.7188 5.4793L10.2539 5.94414L7.65625 8.5418V1.15625ZM3.52188 8.8125H1.3125H0V10.125V13.1875V14.5H1.3125H12.6875H14V13.1875V10.125V8.8125H12.6875H10.4781L9.16563 10.125H12.6875V13.1875H1.3125V10.125H4.83437L3.52188 8.8125ZM11.8125 11.6562C11.8125 11.4822 11.7434 11.3153 11.6203 11.1922C11.4972 11.0691 11.3303 11 11.1562 11C10.9822 11 10.8153 11.0691 10.6922 11.1922C10.5691 11.3153 10.5 11.4822 10.5 11.6562C10.5 11.8303 10.5691 11.9972 10.6922 12.1203C10.8153 12.2434 10.9822 12.3125 11.1562 12.3125C11.3303 12.3125 11.4972 12.2434 11.6203 12.1203C11.7434 11.9972 11.8125 11.8303 11.8125 11.6562Z" fill="#333333" />
        </g>
        <defs>
            <clipPath id="clip0_220_338">
                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
  )
}
